import { useTranslation } from 'react-i18next';
import { Icon, Row, Text } from 'ui';

type P = {
  count: number;
  liked: boolean;
};

const LikeCount = ({ count, liked }: P) => {
  const { t } = useTranslation();
  return (
    <Row align="middle" className="like-count">
      {liked ? (
        <Icon className="like-count__like-icon__filled" icon="heart-fill" size="extra-small" />
      ) : (
        <Icon className="like-count__like-icon" icon="heart-line" size="extra-small" />
      )}
      <Text size="small" type="secondary">
        {t('likesCount', { count })}
      </Text>
    </Row>
  );
};

export default LikeCount;
